import { sendTosaRequest } from './sendTosaRequest';
import updateLeadQuery from './updateLead.graphql';

import type { UpdateLeadMutation, UpdateLeadMutationVariables } from './types';

type Mutation = UpdateLeadMutation;
type Variables = UpdateLeadMutationVariables;

interface UpdateLeadInput {
  firstName: string;
  zip: string;
}

const CURRENT_BLUEPRINT_VERSION = '0.0.0';

export async function updateLead({ firstName, zip }: UpdateLeadInput) {
  return sendTosaRequest<Variables, Mutation>({
    query: updateLeadQuery,
    variables: {
      lead: {
        blueprintVersion: CURRENT_BLUEPRINT_VERSION,
        firstName,
        zip,
      },
    },
  });
}
